import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MockService {
	public mockEndpoints: any = {
		'selections':'selections',
		'order':'order',
		'categories/cloud-tags':'cloud-tags',
		'contents/search?page=0&size=1':'search',
		'contents/search?page=0&size=3':'search',
		'contents/3974':'content',
		'content-sources':'content-sources',
		'content-sources/16':'content-source',
		'content-sources/5':'content-source',
		'collections/637/contents':'collection',
		'collections/19083/playlist':'playlist',
	}

  constructor() { }

	public getMockData(url:string){
    let source = this.mockEndpoints[url];
		let mockData = {
			"order": {"order":["AUDIO","IMAGE","VIDEO","DOCUMENT","COLLECTION"]},
			"selections": {"1":[{"type":"FORMAT_VIDEO","items":[637,18912,2231]},{"type":"FORMAT_AUDIO","items":[19083,12720,19146]},{"type":"FORMAT_DOCUMENT","items":[968,16422,457]},{"type":"FORMAT_IMAGE","items":[13123,19027,179]},{"type":"FORMAT_COLLECTION","items":[1181,2068,10851]}],"2":[{"type":"FORMAT_VIDEO","items":[637,717,528]},{"type":"FORMAT_AUDIO","items":[]},{"type":"FORMAT_DOCUMENT","items":[]},{"type":"FORMAT_IMAGE","items":[11499,134,88]},{"type":"FORMAT_COLLECTION","items":[]}],"3":[{"type":"FORMAT_VIDEO","items":[]},{"type":"FORMAT_AUDIO","items":[]},{"type":"FORMAT_DOCUMENT","items":[]},{"type":"FORMAT_IMAGE","items":[]},{"type":"FORMAT_COLLECTION","items":[]}]},
			'cloud-tags': [{"id":2,"title":"Alimentação","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/c19444a9-ffbe-4ad9-83ba-2212e85677fc-2017-08-25T20-09-52-020Z"},{"id":3,"title":"Arquitetura","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/a47e4eba-2f67-4e26-aa76-11667eabae81-2017-08-25T19-35-34-388Z"},{"id":5,"title":"Artes Visuais","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/df062231-d405-4ec8-a59d-d92bf2cab7a0-2017-08-26T01-14-45-887Z"},{"id":1,"title":"Cidadania","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/f212d28a-201e-4fc6-97a0-86102d80be5d-2017-08-26T00-48-43-119Z"},{"id":6,"title":"Cinema e Vídeo","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/ec983da8-d209-464f-b726-ec4b58df5c17-2017-08-26T01-55-32-614Z"},{"id":9,"title":"Dança","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/4600bedd-91e5-4877-9eee-048a1f7f6824-2017-08-26T01-07-44-771Z"},{"id":10,"title":"Educação","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/142ad207-e4a1-47a7-9f88-d156e62f418a-2017-08-26T01-45-59-388Z"},{"id":11,"title":"Esporte","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/9c24dc73-d1aa-4448-b4b6-0eef00e6fed8-2017-08-26T01-45-19-631Z"},{"id":13,"title":"Literatura","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/67c2c34b-19b2-450d-b2a1-3f3b4cbd548c-2017-08-26T01-45-43-482Z"},{"id":14,"title":"Meio Ambiente","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/9e9caa16-cea0-4d3f-96b4-58df2961e6c7-2017-10-16T22-41-17-574Z"},{"id":15,"title":"Música","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/8a7aff23-9a09-467f-bf57-cd3237aacdd3-2017-08-26T01-43-56-945Z"},{"id":19,"title":"Tecnologias","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/b1e051d8-7684-4c1b-b9fa-8e02163dd367-2017-10-16T22-35-37-316Z"},{"id":20,"title":"Turismo Social","avatar":"https://d2m4dnlcgwixef.cloudfront.net/category/b01ff1be-802a-4016-9ad6-4fdf5f43afc6-2017-10-16T22-23-27-514Z"},{"id":24,"title":"ninini","avatar":null}],
			"search": {"contents":{"content":[{"id":19083,"credits":[{"id":57452,"title":"Centro de Pesquisa e Formação"},{"id":57451,"title":"Marcus Vinicius da Cunha"}],"thumbnail":"https://d2m4dnlcgwixef.cloudfront.net/content/thumbnail/3cf30117-ce75-4834-ab1e-e0bf7cff88d8-2017-10-16T17-07-19-923Z","format":"FORMAT_COLLECTION","publishAs":{"name":"Centro de Pesquisa e Formação","preSigned":null,"id":8,"publisherType":"CONTENT_SOURCE"},"mainCategory":{"id":10,"title":"Educação"},"title":"Contextos - O pensamento de John Dewey","shortDescription":"O professor Marcus Vinicius da Cunha discorre sobre a obra do filósofo da educação morto em 1952","counterViews":28,"collectionCount":5,"broadcastingConsumptionModeIds":[],"allowedConsumptionModes":["MODE_WATCH","MODE_LIKE","MODE_DOWNLOAD","MODE_FOLOW","MODE_RATE","MODE_SHARE","MODE_EMBED","MODE_MANAGE","MODE_COLLECTION"],"contentTypeCategory":"CONTENT_TYPE_CATEGORY_COMPOSED","live":false,"video360":false,"modifiedDate":"2017-10-17T11:31:10-0200","startDateAvailability":"2017-10-17T00:00:00-0200","creator":"Sesc Digital Adm","categorizations":[{"contentCategory":{"id":10,"active":true,"cloudTag":true,"avatar":"category/142ad207-e4a1-47a7-9f88-d156e62f418a-2017-08-26T01-45-59-388Z","titles":[{"language":{"id":1,"name":"Português","initials":"PT","translateApp":true,"systemDefault":true,"active":true},"contentCategoryId":10,"title":"Educação","contentCategory":null}]},"order":2}]},{"id":12720,"credits":[{"id":87181,"title":"Adoniran Barbosa"}],"thumbnail":"https://d2m4dnlcgwixef.cloudfront.net/content/thumbnail/edfc1cbb-d95b-4278-9f98-7dbfbaa56762-2017-04-19T14-42-25-097Z","format":"FORMAT_AUDIO","publishAs":{"name":"Sesc Digital","preSigned":null,"id":8,"publisherType":"SESC_UNIT"},"mainCategory":{"id":15,"title":"Música"},"mainSpeciality":{"id":42,"title":"show"},"title":"Adoniran Barbosa - Ao Vivo","shortDescription":"Show do cantor paulista Adoniran Barbosa e o Grupo Talismã no Sesc Consolação em 1980","counterViews":159,"collectionCount":0,"broadcastingConsumptionModeIds":[],"allowedConsumptionModes":["MODE_WATCH","MODE_LIKE","MODE_DOWNLOAD","MODE_FOLOW","MODE_RATE","MODE_SHARE","MODE_EMBED","MODE_MANAGE","MODE_COLLECTION"],"contentTypeCategory":"CONTENT_TYPE_CATEGORY_SIMPLE","live":false,"video360":false,"modifiedDate":"2018-05-28T14:45:17-0300","createdDate":"2017-04-18T19:08:30-0300","startDateAvailability":"2018-05-28T00:00:00-0300","creator":"Sesc Digital Adm","categorizations":[{"contentCategory":{"id":15,"active":true,"cloudTag":true,"avatar":"category/8a7aff23-9a09-467f-bf57-cd3237aacdd3-2017-08-26T01-43-56-945Z","titles":[{"language":{"id":1,"name":"Português","initials":"PT","translateApp":true,"systemDefault":true,"active":true},"contentCategoryId":15,"title":"Música","contentCategory":null}]},"order":0}]},{"id":19146,"credits":[{"id":82749,"title":"Selo Sesc"}],"thumbnail":"https://d2m4dnlcgwixef.cloudfront.net/content/thumbnail/4c3b386d-fed7-4fee-a532-292e74111edf-2017-10-16T19-41-37-271Z","format":"FORMAT_AUDIO","publishAs":{"name":"Selo Sesc","preSigned":null,"id":3,"publisherType":"CONTENT_SOURCE"},"mainCategory":{"id":15,"title":"Música"},"mainSpeciality":{"id":36,"title":"podcast"},"title":"Rádio Apocalipse #1 - Cássia Carrascoza","shortDescription":"Áudio do programa da Rádio Apocalipse que entrevista a flautista Cássia Carrascoza","counterViews":40,"collectionCount":0,"broadcastingConsumptionModeIds":[],"allowedConsumptionModes":["MODE_WATCH","MODE_LIKE","MODE_DOWNLOAD","MODE_FOLOW","MODE_RATE","MODE_SHARE","MODE_EMBED","MODE_MANAGE","MODE_COLLECTION"],"contentTypeCategory":"CONTENT_TYPE_CATEGORY_SIMPLE","live":false,"video360":false,"modifiedDate":"2018-04-30T00:57:04-0300","startDateAvailability":"2018-04-30T00:00:00-0300","creator":"Sesc Digital Adm","categorizations":[{"contentCategory":{"id":15,"active":true,"cloudTag":true,"avatar":"category/8a7aff23-9a09-467f-bf57-cd3237aacdd3-2017-08-26T01-43-56-945Z","titles":[{"language":{"id":1,"name":"Português","initials":"PT","translateApp":true,"systemDefault":true,"active":true},"contentCategoryId":15,"title":"Música","contentCategory":null}]},"order":0}]}],"totalElements":3,"last":true,"totalPages":1,"first":true,"sort":null,"numberOfElements":3,"size":3,"number":0},"searchTerms":null,"fuzzySearchTerms":""},
			"playlist": {"title":"Contextos - O pensamento de John Dewey","items":[{"id":18646,"title":"Contextos - O Pensamento de John Dewey - Dia 1","position":1,"duration":8736,"format":"FORMAT_AUDIO","live":false,"video360":false},{"id":18647,"title":"Contextos - O Pensamento de John Dewey - Dia 2","position":2,"duration":11202,"format":"FORMAT_AUDIO","live":false,"video360":false},{"id":18649,"title":"Contextos - O Pensamento de John Dewey - Dia 3","position":3,"duration":9328,"format":"FORMAT_AUDIO","live":false,"video360":false},{"id":18651,"title":"Contextos - O Pensamento de John Dewey - Dia 4","position":4,"duration":11482,"format":"FORMAT_AUDIO","live":false,"video360":false},{"id":18653,"title":"Contextos - O Pensamento de John Dewey - Dia 5","position":5,"duration":10097,"format":"FORMAT_AUDIO","live":false,"video360":false}]},
			"collection": {
				"contents": {
					"content": [{
							"id": 4078,
							"credits": [{
								"id": 11383,
								"title": "Sesc São Paulo"
							}],
							"thumbnail": "/files/programacao/377ac21d/49a9/437c/9a84/a17467aec493.jpg",
							"format": "FORMAT_DOCUMENT",
							"publishAs": {
								"name": "Espaço de Leitura",
								"preSigned": null,
								"id": 10,
								"publisherType": "CONTENT_SOURCE"
							},
							"mainCategory": {
								"id": 8,
								"title": "Comunicação"
							},
							"mainSpeciality": {
								"id": 39,
								"title": "revista"
							},
							"title": "Revista E - TESTE ISSUU",
							"counterViews": 0,
							"collectionCount": 0,
							"broadcastingConsumptionModeIds": [],
							"allowedConsumptionModes": [
								"MODE_WATCH",
								"MODE_LIKE",
								"MODE_DOWNLOAD",
								"MODE_FOLOW",
								"MODE_RATE",
								"MODE_SHARE",
								"MODE_EMBED",
								"MODE_MANAGE",
								"MODE_COLLECTION"
							],
							"contentTypeCategory": "CONTENT_TYPE_CATEGORY_SIMPLE",
							"live": false,
							"video360": false,
							"modifiedDate": "2017-07-03T14:11:46-0300",
							"startDateAvailability": "2017-07-03T00:00:00-0300",
							"creator": "Sesc Digital",
							"categorizations": [{
								"contentCategory": {
									"id": 8,
									"active": true,
									"cloudTag": true,
									"titles": [{
											"language": {
												"id": 1,
												"name": "Português",
												"initials": "PT",
												"translateApp": true,
												"systemDefault": true,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Comunicação",
											"contentCategory": null
										},
										{
											"language": {
												"id": 3,
												"name": "Español",
												"initials": "ES",
												"translateApp": true,
												"systemDefault": false,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Comunicación",
											"contentCategory": null
										},
										{
											"language": {
												"id": 2,
												"name": "English",
												"initials": "EN",
												"translateApp": true,
												"systemDefault": false,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Communication",
											"contentCategory": null
										}
									]
								},
								"order": 0
							}]
						},
						{
							"id": 3763,
							"credits": [{
								"id": 11314,
								"title": "Sesc São Paulo"
							}],
							"thumbnail": "/files/programacao/377ac21d/49a9/437c/9a84/a17467aec493.jpg",
							"format": "FORMAT_VIDEO",
							"publishAs": {
								"name": "Memórias",
								"preSigned": null,
								"id": 11,
								"publisherType": "CONTENT_SOURCE"
							},
							"mainCategory": {
								"id": 8,
								"title": "Comunicação"
							},
							"mainSpeciality": {
								"id": 47,
								"title": "programa"
							},
							"title": "SESC Notícias - 93",
							"counterViews": 0,
							"collectionCount": 0,
							"broadcastingConsumptionModeIds": [],
							"allowedConsumptionModes": [
								"MODE_WATCH",
								"MODE_LIKE",
								"MODE_DOWNLOAD",
								"MODE_FOLOW",
								"MODE_RATE",
								"MODE_SHARE",
								"MODE_EMBED",
								"MODE_MANAGE",
								"MODE_COLLECTION"
							],
							"contentTypeCategory": "CONTENT_TYPE_CATEGORY_SIMPLE",
							"live": false,
							"video360": false,
							"modifiedDate": "2017-03-31T13:27:42-0300",
							"startDateAvailability": "2017-03-31T00:00:00-0300",
							"creator": "Sesc Digital",
							"categorizations": [{
								"contentCategory": {
									"id": 8,
									"active": true,
									"cloudTag": true,
									"titles": [{
											"language": {
												"id": 1,
												"name": "Português",
												"initials": "PT",
												"translateApp": true,
												"systemDefault": true,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Comunicação",
											"contentCategory": null
										},
										{
											"language": {
												"id": 3,
												"name": "Español",
												"initials": "ES",
												"translateApp": true,
												"systemDefault": false,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Comunicación",
											"contentCategory": null
										},
										{
											"language": {
												"id": 2,
												"name": "English",
												"initials": "EN",
												"translateApp": true,
												"systemDefault": false,
												"active": true
											},
											"contentCategoryId": 8,
											"title": "Communication",
											"contentCategory": null
										}
									]
								},
								"order": 0
							}]
						}
					],
					"last": true,
					"totalPages": 1,
					"totalElements": 10,
					"numberOfElements": 10,
					"first": true,
					"sort": null,
					"size": 50,
					"number": 0
				},
				"searchTerms": null,
				"fuzzySearchTerms": null
			},
			"content-sources": [
				{id:5,featured_image:'assets/images/list.png',title_br:'Infinito Movimento',content_br:'<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus ipsam voluptates, sed quis nisi aspernatur alias facere quaerat odio inventore excepturi nostrum dolores corporis maxime suscipit, fuga ex aliquam totam.</p>'},
				{id:16,featured_image:'assets/images/list.png',title_br:'Alcance dos sentidos',content_br:'<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus ipsam voluptates, sed quis nisi aspernatur alias facere quaerat odio inventore excepturi nostrum dolores corporis maxime suscipit, fuga ex aliquam totam.</p>'},
				{id:5,featured_image:'assets/images/list.png',title_br:'Olhar o Vento',content_br:'<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ducimus ipsam voluptates, sed quis nisi aspernatur alias facere quaerat odio inventore excepturi nostrum dolores corporis maxime suscipit, fuga ex aliquam totam.</p>'}
			],
			"content-source": {
				"id": 5,
				"name": "Acervo Sesc de Arte Brasileira",
				"avatar": "/files/programacao/377ac21d/49a9/437c/9a84/a17467aec493.jpg",
				"tubePic": "/files/programacao/377ac21d/49a9/437c/9a84/a17467aec493.jpg",
				"country": {
					"id": 44,
					"name": "África do Sul",
					"continent": "AFRICA",
					"active": true,
					"systemDefault": false,
					"awsCode": "ZA"
				},
				"url": "http://www.sescsp.org.br",
				"active": true,
				"description": "<p>Ao longo de sua existência, o </p><p><b>Sesc São Paulo</b></p><p> compôs um acervo de </p><p><br/></p><p>obras de arte, produzidas nos mais diversos suportes e técnicas, <br/>evidenciando artistas que se destacaram na cena paulistana e brasileira <br/>em diferentes períodos. <br/></p><!--EndFragment--><p><br/></p><p><br/></p>"
			},

			"content":	{
				"id": 3974,
				"translatedContent": {
					"title": "Sesc Pompeia 2",
					"description": "<p>Pug descrição<br/>alterando descricao para a consulta</p>",
					"catalogCard": "<p>Ficha técnica<br/></p>"
				},
				"indicativeClass": 0,
				"releaseDay": 24,
				"releaseMonth": 1,
				"releaseYear": 2017,
				"releaseEndDay": 10,
				"releaseEndMonth": 10,
				"releaseEndYear": 2017,
				"publishAs": {
					"name": "Selo Sesc",
					"preSigned": {
						"url": "/content-source/bfa8310d-9478-4412-a5f4-7f...3D",
						"expiration": 1500062476252
					},
					"id": 3,
					"publisherType": "CONTENT_SOURCE"
				},
				"transcription": null,
				"fileId": null,
				"pages": 0,
				"playerKey": "5657c9a1dd1596e8a769981e75f01814",
				"video360": false,
				"counterViews": 0,
				"format": "FORMAT_IMAGE",
				"live": false,
				"snippet": "adsasdadasdas",
				"tags": [{
						"id": 5,
						"text": "acervo sesc de arte brasileira",
						"clazz": "TAG_DESCRIPTION",
						"active": true
					},
					{
						"id": 7,
						"text": "Abram Szajman",
						"clazz": "TAG_PERSONALITY",
						"active": true
					}
				],
				"categories": [{
					"id": 5,
					"title": "Artes Visuais"
				}],
				"specialities": [{
					"id": 17,
					"title": "entrevista"
				}],
				"principalTaggings": [{
					"id": 11374,
					"sescUnit": {
						"id": 43,
						"name": "Campinas",
						"type": "UNIT_OPERATIONAL",
						"city": "Campinas",
						"address": "Rua Dom José I, 270/333",
						"latitude": "-22.904155",
						"longitude": "-47.074389",
						"url": "http://www.sescsp.org.br/campinas",
						"avatar": "sesc-unit/dc2e2e22-a2be-49dc-a23e-095d8877271c/2016-05-25T23:19:34.704Z",
						"sescId": 75,
						"active": true,
						"ips": [],
						"descriptions": [{
								"language": {
									"id": 1,
									"name": "Português",
									"initials": "PT",
									"translateApp": true,
									"systemDefault": true,
									"active": true
								},
								"description": "<p> <br/></p>"
							},
							{
								"language": {
									"id": 3,
									"name": "Español",
									"initials": "ES",
									"translateApp": true,
									"systemDefault": false,
									"active": true
								},
								"description": "<p> <br/></p>"
							},
							{
								"language": {
									"id": 2,
									"name": "English",
									"initials": "EN",
									"translateApp": true,
									"systemDefault": false,
									"active": true
								},
								"description": "<p> <br/></p>"
							}
						]
					},
					"contentSource": null,
					"tag": null,
					"order": 0,
					"creditId": 43
				}],
				"minimunTimeCountPreview": 1,
				"featured": null,
				"publicationDate": "30/06/2017",
				"thumbnail": "/files/programacao/377ac21d/49a9/437c/9a84/a17467aec493.jpg",
				"collectionCount": 0,
				"creatorId": 3958
			}


		}
		return mockData[source];

	}

}
